export default Object.freeze({
  TITLE: '개인정보접속기록 조회',
  TABLE_TITLE: '조회결과',
  INPUT_ADMIN_ID: '작성자 입력',
  CUSTOM_TAB: '회원정보 접속기록',
  ADMIN_TAB: '운영자정보 접속기록',
  MALL: '쇼핑몰',
  ALL_MALL: '전체 쇼핑몰 대상 처리 내역',
  SEARCH: '조회',
  EXCEL_DOWNLOAD: '엑셀 다운로드',
  EXCEL_UPLOAD: '엑셀 업로드',
  EXCEL_CREATE: '엑셀 생성',
  CERTIFICATION: '인증',
  ADD: '등록',
  BLOCK: '차단',
  DELETE: '삭제',
  CHANGE: '수정',
  RESET: '초기화',
  CALENDAR: '기간',
  SEARCH_TYPE: '상세검색',
  ALL_SEARCH_TYPE: '통합검색',
  DETAIL: '상세',
  ACCESS_PAGE: '접속페이지',
  SEARCH_KEYWORD: '검색조건',
  COUNT: '처리건수',
  IDENTIFIERS: '처리대상',
  FILENAME: '파일명',
  REASON: '사유',
  CERTIFY_TYPE: '인증수단',
  CERTIFY_VALUE: '인증번호',

  //grid
  ACCESS_DATE_TIME: '접속 일시',
  IP: '접속 IP',
  ADMIN_ID: '운영자ID',
  MENU_NAME: '메뉴',
  PAGE_NAME: '접속페이지',
  ACCESS_URL: '접속 url',
  WORKING_TYPE_DESCRIPTION: '수행업무',

  //notice
  NOTICE_1: '개인정보의 안정성 확보에 필요한 조치에 관한 사항',
  NOTICE_2:
    '개인정보의 기술적 관리적 보호조치 기준에 따라 정보통신서비스 제공자 등은 개인정보취급자가' +
    '개인정보처리시스템에 접속한 기록을 월 1회 이상 정기적으로 확인·감독하여야 하며,',
  NOTICE_2_1: '시스템 이상 유무의 확인 등을 위해 최소 2년 이상 접속기록을 보존·관리하여야 합니다.',
  NOTICE_3: '회원정보 접속기록 기간 조회의 경우 오늘 기준 2년 이내 데이터를 최대 6개월까지 선택하여 조회가 가능합니다.',
  NOTICE_4:
    '운영자정보 접속기록 기간 조회의 경우 오늘 기준 5년 이내 데이터를 최대 6개월까지 선택하여 조회가 가능합니다.',
  EXCEL_RANGE_VALIDATION_CHECK_MESSAGE: '조회기간은 최대 6개월 까지 조회 가능합니다.',
});
